export default __webpack_public_path__ + "tmp_assets/styles/solar/theme.css.liquid";